import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../../mensajes2";
import { Dimmer } from "../../spinner";

import { formatMoneda, validaMonto } from "../../../util/varios";
import "react-tabs/style/react-tabs.css";
import axios from "axios";
import { DangerButton, SuccessButton } from "../../../ui/buttons/Button";
import { Input, Radio, Textarea } from "../../../ui/inputs/Input";

export const ActualizarClasificador = (props) => {
  let token = localStorage.getItem("jwtToken");
  let op = require("../../../../src/modulos/datos");
  const btnCancela = useRef();
  const btnAcepta = useRef();
  const [activate, setActivate] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [deshabilitado] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const txtMtsSi = useRef();
  const txtMtsNo = useRef();
  const [visibleF, setVisibleF] = useState("hidden");
  const txtID = useRef();
  const txtCod = useRef();
  const txtMonto = useRef();
  const txtNunid = useRef();
  const txtAnual = useRef();
  const txtDescrip = useRef();
  const txtMensual = useRef();
  const txtEventual = useRef();
  const [values, setValues] = useState({
    idtipopublicidad: "",
    codigoordenanza: "",
    periodopago: "",
    descripcion: "",
    mts2: 0.0,
    numerounidad: 0.0,
    monto: 0.0,
  });

  const Actualizar = (operacion) => {
    let endpoint = `${op.conexion}/api/publicidad/createtpublicidad/${operacion}`;
    let body;
    setActivate(true);
    body = {
      nid: parseInt(txtID.current.value),
      cod: txtCod.current.value,
      descr: txtDescrip.current.value.trim(),
      val: txtMonto.current.value.trim().replace(/\./g, "").replace(",", "."),
      mts: txtMtsSi.current.checked ? true : false,
      nunid: txtNunid.current.value.trim().replace(/\./g, "").replace(",", "."),
      peri:
        txtAnual.current.checked === true
          ? "0"
          : txtMensual.current.checked === true
          ? "1"
          : "2",
    };
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          console.log(response.data);
          if (props.operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "Registro Creado Correctamente.",
              icono: "exito",
            });
          } else if (props.operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "Registro Modificado Correctamente.",
              icono: "exito",
            });
          } else if (props.operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "Registro Eliminado Correctamente.",
              icono: "exito",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };
  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    if (
      mensaje.texto == "Registro Creado Correctamente." ||
      mensaje.texto == "Registro Modificado Correctamente." ||
      mensaje.texto == "Registro Eliminado Correctamente."
    ) {
      blanquear();
      props.onHideRenderizar();
      props.onHideCancela();
    }
  };

  const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (
      event.target.value === "" ||
      parseFloat(
        event.target.value.trim().replace(/\./g, "").replace(",", ".")
      ) === 0.0
    ) {
      event.target.value = "0,00";
    }
    if (event.which >= 37 && event.which <= 40) {
      event.preventDefault();
    }

    let e = event.target.value
      .replace(/\D/g, "")
      .replace(/([0-9])([0-9]{2})$/, "$1.$2")
      .replace(/\B(?=(\d{3})+(?!\d)\.?)/g, ",");

    return formatMoneda(e);
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;
    if (txtCod.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Por Favor Introdusca el Código de Ordenanza",
        icono: "informacion",
      });
      sigue = false;
      txtCod.current.focus();
    } else if (txtMonto.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Por Favor Introdusca el Monto de la Unidad",
        icono: "informacion",
      });

      sigue = false;
      txtMonto.current.focus();
    } else if (txtDescrip.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Introducir la Descripción",
        icono: "informacion",
      });

      sigue = false;
      txtDescrip.current.focus();
    } else if (sigue === true) {
      Actualizar(props.operacion);
    }
  };

  const blanquear = () => {
    setActivate(false);
    setValues({
      idtipopublicidad: "",
      codigoordenanza: "",
      periodopago: "",
      descripcion: "",
      mts2: 0.0,
      numerounidad: 0.0,
      monto: 0.0,
    });
    setOperacion(0);
    setVisibleF("hidden");
  };

  const onCheck = () => {
    if (txtMtsNo.current.checked) {
      setVisibleF("visible");
    } else if (txtMtsSi.current.checked) {
      setVisibleF("hidden");
    }
  };

  const onChange = (event) => {
    if (event.target.name === "descripcion") {
      event.target.value = event.target.value.toUpperCase();
    }
    setValues({ ...values, [event.target.name]: event.target.value });
  };
  const cancelar = (e) => {
    e.preventDefault();
    blanquear();
    props.onHideCancela();
  };
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        btnAcepta.current.focus();
        setOperacion(props.operacion);
        if (props.operacion !== 1) {
          setValues(props.publicidad);

          if (props.publicidad.mts2 === false) {
            setVisibleF("visible");
          } else {
            setVisibleF("hidden");
          }
        }
      }}
    >
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between text-light azulGradiant">
        <h3 className="fw-bold m-0">
          {operacion === 1
            ? "Incluir Clasificador de Publicidad."
            : operacion === 2
            ? "Modificar Clasificador de Publicidad."
            : operacion === 3
            ? "Eliminar Clasificador de Publicidad."
            : "Consultar Clasificador de Publicidad."}
        </h3>
        <a type="button" className="fw-bold text-light fs-6" onClick={cancelar}>
          Salir <i className="fas fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body className="col-12 m-0 p-2 d-flex flex-wrap">
        <div className="col-3 m-0 p-0">
          <Input
            label="Código:"
            disabled={true}
            ref={txtID}
            name="idtipopublicidad"
            value={values.idtipopublicidad}
          />
        </div>
        <div className="col-5 m-0 p-0 pl-2">
          <Input
            label="Código/Ordenanza:"
            disabled={operacion === 4 || operacion === 3 ? true : deshabilitado}
            ref={txtCod}
            name="codigoordenanza"
            defaultValue={values && values.codigoordenanza.trim()}
          />
        </div>
        <div className="col-4 m-0 p-0 pl-2">
          <Input
            label="Monto de la Unidad:"
            disabled={operacion === 4 || operacion === 3 ? true : deshabilitado}
            ref={txtMonto}
            name="monto"
            defaultValue={
              values && values.monto
                ? formatMoneda(
                    values.monto.toString().replace(",", "").replace(".", ","),
                    ",",
                    ".",
                    2
                  )
                : ""
            }
            onKeyUp={handleInputMontoChange}
            onBlur={handleInputMontoChange}
            id="inputMonto"
          />
        </div>
        <fieldset className="col-12 m-0 p-2 d-flex flex-wrap rounded border-azul">
          <legend className="float-none w-auto m-0">Periodo de Cobranza</legend>
          <div className="col m-0 p-0">
            <Radio
              label="Anual"
              type="radio"
              disabled={
                operacion === 4 || operacion === 3 ? true : deshabilitado
              }
              ref={txtAnual}
              className="custom-control-input"
              id="customControlValidation7"
              name="periodopago"
              defaultChecked={
                props.publicidad && props.publicidad.periodopago === 0
                  ? true
                  : false
              }
              required
            />
          </div>
          <div className="col m-0 p-0">
            <Radio
              label="Mensual"
              disabled={
                operacion === 4 || operacion === 3 ? true : deshabilitado
              }
              ref={txtMensual}
              className="custom-control-input"
              id="customControlValidation8"
              name="periodopago"
              defaultChecked={
                props.publicidad && props.publicidad.periodopago === 1
                  ? true
                  : false
              }
              required
            />
          </div>
          <div className="col m-0 p-0">
            <Radio
              label="Eventual"
              disabled={
                operacion === 4 || operacion === 3 ? true : deshabilitado
              }
              ref={txtEventual}
              className="custom-control-input"
              id="customControlValidation9"
              name="periodopago"
              defaultChecked={
                props.publicidad && props.publicidad.periodopago === 2
                  ? true
                  : false
              }
              required
            />
          </div>
        </fieldset>
        <fieldset className="col-12 m-0 p-2 d-flex flex-wrap rounded border-azul">
          <legend className="float-none w-auto m-0">Unidad de Medida</legend>
          <div className="col-4 m-0 p-0">
            <Radio
              label="Mtrs2"
              disabled={
                operacion === 4 || operacion === 3 ? true : deshabilitado
              }
              ref={txtMtsSi}
              name="mts2"
              id="Uni1"
              defaultChecked={
                props.publicidad && props.publicidad.mts2 === true
                  ? true
                  : false
              }
              onChange={onCheck}
            />
          </div>
          <div className="col-4 m-0 p-0">
            <Radio
              label="Otro"
              disabled={
                operacion === 4 || operacion === 3 ? true : deshabilitado
              }
              ref={txtMtsNo}
              name="mts2"
              id="Uni2"
              defaultChecked={
                props.publicidad && props.publicidad.mts2 === false
                  ? true
                  : false
              }
              onChange={onCheck}
            />
          </div>
          <div className="col-4 m-0 p-0" style={{ visibility: visibleF }}>
            <Input
              label="Cnt/Und:"
              disabled={
                operacion === 4 || operacion === 3 ? true : deshabilitado
              }
              ref={txtNunid}
              name="numerounidad"
              defaultValue={
                values && values.numerounidad
                  ? formatMoneda(
                      values.numerounidad
                        .toString()
                        .replace(",", "")
                        .replace(".", ","),
                      ",",
                      ".",
                      2
                    )
                  : 1.0
              }
              onKeyUp={handleInputMontoChange}
              onBlur={handleInputMontoChange}
              id="inputNuid"
            />
          </div>
          <div className="col-12 m-0 p-0">
            <Textarea label = 'Descripción:'
              style={{ height: 70 }}
              ref={txtDescrip}
              disabled={
                operacion === 4 || operacion === 3 ? true : deshabilitado
              }
              name="descripcion"
              defaultValue={
                values && values.descripcion !== null
                  ? values.descripcion.trim()
                  : ""
              }
              onChange={onChange}
              placeholder="DESCRIBA EL NOMBRE DEL CLASIFICADOR"
            />
          </div>
        </fieldset>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton
          ref={btnAcepta}
          disabled={operacion === 4 ? true : false}
          onClick={onChangeValidar}
        >
          Aceptar
        </SuccessButton>
        <DangerButton ref={btnCancela} onClick={cancelar}>
          Cancelar
        </DangerButton>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({
                mostrar: false,
                titulo: "",
                texto: "",
                icono: "",
              });
        }}
      />

      <Dimmer active={activate} inverted></Dimmer>
    </Modal>
  );
};
